import { allRoutes } from "./allRoutes";
import { createPageLinks } from "./v2/pageLinks";
export const pageLinks = {
    system: createPageLinks(allRoutes.system),
};
